import React from 'react';
import { Avatar, AvatarProps } from '../Avatar';

export interface BrandedAvatarProps extends AvatarProps {
  /**
   * Primary color for the halo gradient
   */
  primaryColor?: string;
  
  /**
   * Whether to show the branded halo
   * @default true
   */
  withHalo?: boolean;

  /**
   * Whether to show the edit badge (gear icon)
   * @default false
   */
  showEditBadge?: boolean;
}

export const BrandedAvatar: React.FC<BrandedAvatarProps> = ({
  primaryColor = '#6366f1',
  withHalo = true,
  showEditBadge = false,
  className = '',
  ...props
}) => {
  const avatarContent = (
    <Avatar
      {...props}
      className={`min-w-full bg-white shadow-inner`}
    />
  );

  if (!withHalo) {
    return (
      <div className={`relative inline-block ${className}`}>
        {avatarContent}
        {showEditBadge && <EditBadge />}
      </div>
    );
  }

  return (
    <div className={`relative inline-block group ${className}`}>
      <div 
        className="rounded-full p-[1.5px] transition-all duration-300 group-hover:scale-105"
        style={{ 
          background: `linear-gradient(135deg, ${primaryColor}, transparent)`,
        }}
      >
        <div className="rounded-full p-[1.5px] bg-[#000103] flex items-center justify-center">
          {avatarContent}
        </div>
      </div>
      {showEditBadge && <EditBadge />}
    </div>
  );
};

const EditBadge: React.FC = () => (
  <div className="absolute bottom-0 right-0 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 pointer-events-none translate-x-[15%] translate-y-[15%]">
    <svg 
      className="w-3.5 h-3.5 text-white" 
      fill="currentColor" 
      viewBox="0 0 20 20"
      style={{ 
        filter: 'drop-shadow(0 0 1px rgba(0,0,0,0.8)) drop-shadow(0 0 2px rgba(0,0,0,0.6))' 
      }}
    >
      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
    </svg>
  </div>
);
